<template>
  <el-dialog
    :title="isEdit ? '编辑课程' : '新增课程'"
    :visible.sync="dialogVisible"
    width="800px"
    top="5%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
    class="video-add-dialog"
  >
    <div class="dialog-body">
      <el-form
        ref="addForm"
        :model="form"
        :rules="rules"
        label-width="90px"
      >
        <!-- 基础信息 -->
        <div class="form-section">
          <div class="section-title">
            <i class="el-icon-document"></i>
            <span>基础信息</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="课程名称" prop="courseName">
                <el-input v-model="form.courseName" placeholder="请输入课程名称" maxlength="50" show-word-limit size="small" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="课程讲师" prop="instructor">
                <el-input v-model="form.instructor" placeholder="请输入讲师姓名" size="small" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="课程类型" prop="courseType">
                <treeselect
                  v-model="form.courseType"
                  :options="categoryOptions"
                  :normalizer="categoryNormalizer"
                  placeholder="请选择课程类型"
                  :clearable="true"
                  :default-expand-level="1"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="课程状态" prop="status">
                <el-select v-model="form.status" placeholder="请选择课程状态" style="width: 100%;" size="small">
                  <el-option label="正常" value="1"></el-option>
                  <el-option label="停用" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="课程封面" prop="cover">
                <div class="cover-area">
                  <div class="cover-upload">
                    <el-upload
                      class="cover-uploader"
                      action=""
                      :http-request="handleCoverUpload"
                      :show-file-list="false"
                      :before-upload="beforeCoverUpload"
                      accept="image/jpeg,image/png"
                    >
                      <div v-if="coverUploading" class="upload-trigger">
                        <i class="el-icon-loading"></i>
                        <div class="tip">上传中...</div>
                      </div>
                      <div v-else-if="form.cover" class="cover-preview">
                        <img :src="form.cover" alt="封面" />
                        <div class="cover-mask">
                          <i class="el-icon-refresh"></i>
                          <span>更换封面</span>
                        </div>
                      </div>
                      <div v-else class="upload-trigger">
                        <i class="el-icon-plus"></i>
                        <div class="tip">上传封面</div>
                        <div class="sub-tip">16:9，jpg/png</div>
                      </div>
                    </el-upload>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="课程简介" prop="description">
                <el-input
                  v-model="form.description"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入课程简介"
                  maxlength="500"
                  show-word-limit
                  size="small"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>

      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取消</el-button>
      <el-button type="primary" size="small" :loading="submitting" @click="handleSubmit">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { addCourse, updateCourse, getCourseCategoryPage, uploadCourseCover } from '@/api/video'

export default {
  name: 'VideoAdd',
  components: { Treeselect },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      submitting: false,
      coverUploading: false,
      categoryOptions: [],
      categoryNormalizer(node) {
        return {
          id: node.id,
          label: node.categoryName,
          children: node.children,
        }
      },
      form: this.getEmptyForm(),
      rules: {
        courseName: [
          { required: true, message: '请输入课程名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' },
        ],
        instructor: [
          { required: true, message: '请输入讲师姓名', trigger: 'blur' },
        ],
        courseType: [
          { required: true, message: '请选择课程类型', trigger: 'change' },
        ],
        status: [
          { required: true, message: '请选择课程状态', trigger: 'change' },
        ],
        cover: [
          { required: true, message: '请上传课程封面', trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    isEdit() {
      return !!this.editData
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.fetchCategories()
        if (this.editData) {
          this.form = {
            courseName: this.editData.courseName || '',
            instructor: this.editData.instructor || '',
            courseType: this.editData.categoryId != null ? this.editData.categoryId : null,
            status: String(this.editData.status != null ? this.editData.status : 1),
            cover: this.editData.coverUrl || '',
            description: this.editData.description || '',
          }
        } else {
          this.form = this.getEmptyForm()
        }
        this.$nextTick(() => {
          if (this.$refs.addForm) {
            this.$refs.addForm.clearValidate()
          }
        })
      }
    },
  },
  methods: {
    async fetchCategories() {
      try {
        const res = await getCourseCategoryPage({ page: 1, limit: 100 })
        if (res.code === 200 && res.data) {
          const records = (res.data.records || []).filter(item => item.status === 1)
          this.categoryOptions = this.buildCategoryTree(records)
        }
      } catch (e) {
        console.error('获取课程分类失败', e)
      }
    },
    buildCategoryTree(list) {
      const map = {}
      const tree = []
      list.forEach(item => {
        map[item.id] = { ...item }
      })
      list.forEach(item => {
        const node = map[item.id]
        if (!item.parentId || !map[item.parentId]) {
          tree.push(node)
        } else {
          const parent = map[item.parentId]
          if (!parent.children) this.$set(parent, 'children', [])
          parent.children.push(node)
        }
      })
      return tree
    },
    getEmptyForm() {
      return {
        courseName: '',
        instructor: '',
        courseType: null,
        status: '1',
        cover: '',
        description: '',
      }
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
    resolveCoverUrl(url) {
      if (!url) return ''
      if (/^https?:\/\//i.test(url)) return url
      let path = url.startsWith('/') ? url : `/${url}`
      // 上传接口返回 /home/file_upload/...，预览地址实际为 /files/...
      path = path.replace(/^\/home\/file_upload/, '/files')
      const base = (
        this.$store.state.IPAss.yl ||
        process.env.VUE_APP_PREVIEW_FILE_URL ||
        ''
      ).replace(/\/$/, '')
      return `${base}${path}`
    },
    beforeCoverUpload(file) {
      const isImage = ['image/jpeg', 'image/png'].includes(file.type)
      if (!isImage) {
        this.$message.error('封面仅支持 jpg、jpeg、png 格式')
        return false
      }
      return true
    },
    async handleCoverUpload({ file }) {
      this.coverUploading = true
      try {
        const res = await uploadCourseCover(file)
        if (res && res.code === 200 && res.data) {
          const data = res.data
          const inner = data.data || {}
          const coverUrl = typeof data === 'string'
            ? data
            : data.accessUrl
              || data.url
              || data.coverUrl
              || data.fileUrl
              || data.path
              || inner.objectName
              || inner.url
          if (!coverUrl) {
            this.$message.error('上传成功，但未获取到封面地址')
            return
          }
          this.form.cover = this.resolveCoverUrl(coverUrl)
          this.$nextTick(() => {
            this.$refs.addForm && this.$refs.addForm.clearValidate('cover')
          })
          this.$message.success('封面上传成功')
        } else {
          this.$message.error((res && res.msg) || '封面上传失败')
        }
      } catch (e) {
        this.$message.error('封面上传失败')
      } finally {
        this.coverUploading = false
      }
    },
    handleSubmit() {
      if (this.coverUploading) {
        this.$message.warning('封面正在上传，请稍候')
        return
      }
      this.$refs.addForm.validate((valid) => {
        if (!valid) {
          this.$message.error('请完善必填项')
          return
        }
        this.doSave()
      })
    },
    async doSave() {
      this.submitting = true
      try {
        const data = {
          courseName: this.form.courseName,
          categoryId: this.form.courseType,
          instructor: this.form.instructor,
          coverType: 2,
          coverUrl: this.form.cover,
          description: this.form.description,
          status: Number(this.form.status),
        }
        if (this.isEdit) {
          data.id = this.editData.id
          await updateCourse(data)
        } else {
          await addCourse(data)
        }
        this.$message.success(this.isEdit ? '修改成功' : '新增成功')
        this.$emit('update:visible', false)
        this.$emit('saved')
      } catch (e) {
        this.$message.error('保存失败')
      } finally {
        this.submitting = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog__body {
  padding: 15px 20px;
}

.form-section {
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 16px 20px;
  margin-bottom: 14px;

  .section-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 14px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;

    i {
      color: #409eff;
      font-size: 15px;
    }
  }
}

.cover-upload {
  display: flex;
  align-items: center;
  gap: 12px;
}

.cover-preview {
  position: relative;
  width: 160px;
  height: 90px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #ebeef5;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .cover-mask {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    opacity: 0;
    transition: opacity 0.2s;
    font-size: 12px;

    i { font-size: 16px; }
  }

  &:hover .cover-mask {
    opacity: 1;
  }
}

.upload-trigger {
  width: 160px;
  height: 90px;
  border: 1px dashed #c0c4cc;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.2s;
  background: #fafafa;

  &:hover {
    border-color: #409eff;
  }

  i {
    font-size: 20px;
    color: #c0c4cc;
    margin-bottom: 4px;
  }

  .tip {
    font-size: 12px;
    color: #606266;
  }

  .sub-tip {
    font-size: 11px;
    color: #909399;
    margin-top: 2px;
  }
}

::v-deep .cover-uploader,
::v-deep .inline-upload {
  display: inline-block;
}

::v-deep .inline-upload .el-upload {
  display: inline-block;
}

.form-tip {
  color: #909399;
  font-size: 12px;
  margin-left: 12px;
}

.dialog-footer {
  text-align: right;
  padding: 10px 20px;
}
</style>
